/** @jsxImportSource @emotion/react */
import { Column } from "primereact/column";
import { TablaFiltrable } from "../../../shared";
import { formatearValor } from "./agregacion";

// Al Excel van los números sin formato, para que se puedan sumar.
const numeroExportable = (valor) => (valor == null ? "" : Math.round(valor * 100) / 100);

/**
 * Los mismos números de la gráfica en una tabla: una fila por categoría y una
 * columna por serie, más el total cuando hay desglose.
 */
export default function TablaAgrupada({
  resultado,
  etiquetaDimension,
  conDesglose,
  simbolo,
  nombreArchivo
}) {
  const { categorias, series, totales, formato } = resultado;
  const filas = categorias.map((c, i) => ({
    clave: c.clave,
    etiqueta: c.etiqueta,
    valores: series.map((s) => s.valores[i]),
    total: totales[i]
  }));

  const columnaValor = (header, valorDe, key) => (
    <Column
      key={key}
      header={header}
      body={(fila) => formatearValor(valorDe(fila), formato, simbolo)}
      exportValue={(fila) => numeroExportable(valorDe(fila))}
      sortable
      sortFunction={(e) =>
        [...e.data].sort((a, b) => ((valorDe(a) ?? -Infinity) - (valorDe(b) ?? -Infinity)) * e.order)
      }
      align="right"
    />
  );

  return (
    <TablaFiltrable conFiltros={false}
      value={filas}
      dataKey="clave"
      size="small"
      stripedRows
      nombreArchivo={nombreArchivo}
      emptyMessage="No hay datos para mostrar"
    >
      <Column header={etiquetaDimension} field="etiqueta" />
      {series.map((s, i) => columnaValor(s.etiqueta, (fila) => fila.valores[i], s.clave))}
      {conDesglose && columnaValor("Total", (fila) => fila.total, "__total")}
    </TablaFiltrable>
  );
}
